<template>
  <div :key="realoadVaraible">
    <Navbar />

    <img
      v-if="! artist_slug"
      center
      style="max-height: 200px; max-width: 300px"
      :src="getHeroImageUrl"
      fluid
      class="custom_hero_img"
    />

    <b-container class="container_homepage" style="">
      <b-row v-if="! artist_slug" class="flex" style="margin: 20px">
        <h3 class="your_choices mr-auto" style="">{{ page_heading }}</h3>
        <!-- todo: search button -->
        <!-- <h4 class="ml-auto" > Search </h4> -->
        <!-- <input v-model="search" placeholder="Search Art..." style="width:40%;border:1px solid #0c0f66;background-color:#0c0f6608;border-radius:5px"> -->

        <div
          class="input-group"
          style="width: 40%; border: 1px solid #0c0f66; border-radius: 50px"
        >
          <input
            v-model="search_art"
            v-debounce:700ms="searchArt"
            type="text"
            class="form-control"
            placeholder="Search"
            style="height: 100%; border: none; border-radius: 50px"
          />
          <div class="input-group-append">
            <button
              class="btn"
              type="button"
              style="background-color: #0c0f66; border-radius: 30px; z-index: 0"
            >
              <b-icon icon="search" style="color: #fff"></b-icon>
            </button>
          </div>
        </div>
      </b-row>

      <Loader v-if="loading" />

      <div v-if="!loading">
        <b-row style="margin: 20px; display: flex; justify-content: space-around" v-show="search_flag">
            <div
            :key="art.id"
            v-for="art in getExploreArt"
            style="
              width: 23%;
              padding: 5px;
              margin: 5px;
              border: none !important;
            "
            class="card ex-card"
          >
            <ArtCard :art_json="art" />
          </div>
        </b-row>

        <div v-show="!search_flag">
          <b-row style="margin: 20px; display: flex; justify-content: space-around" v-if="search_art_list.length > 0">
            <div
            :key="art.id" 
            v-for="art in search_art_list"
            style="
              width: 23%;
              padding: 5px;
              margin: 5px;
              border: none !important;
            "
            class="card ex-card"
          >
            <ArtCard :art_json="art" />
          </div>
        </b-row>
        
          <div v-else>
            <p v-if="artist_slug">Artworks Coming Soon</p>
            <p v-else>No results found</p>
          </div>
        </div>
        <br /><br />

        <div style="display: flex; justify-content: center" class="mx-auto">
          <button
            v-if="previous_url"
            class="btn next-or-previous-btn"
            style="margin: 10px"
            @click="previous_set_images(previous_url)"
          >
            &larr; Previous
          </button>
          <button
            v-if="next_url"
            class="btn next-or-previous-btn"
            style="margin: 10px"
            @click="next_set_images(next_url)"
          >
            Next &rarr;
          </button>
        </div>
      </div>
    </b-container>
    <Footer v-if="! artist_slug" />
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/lodash@4.13.1/lodash.min.js"></script>

<script>
import Navbar from "../components/common/NavBar.vue";
import ArtCard from "../components/common/ArtCard.vue";
import Footer from "../components/common/Footer.vue";
import Loader from "../components/common/Loader.vue";

export default {
  name: "ExploreArt",
  props:["artist_slug"],
  components: {
    Navbar,
    ArtCard,
    Footer,
    Loader,
  },
  data() {
    return {
      loading: false,
      next_url: "",
      previous_url: "",
      filter_string: "",
      current_route_name: "",
      page_heading: "Explore Art",
      realoadVaraible: 1,
      search_art: "",
      search_flag: true,
      search_art_list: {},
    };
  },
  // watch:{
  //     search_art(newVal,oldVal){
  //         this.searchArt()
  //     }
  // },

  methods: {
    reload() {
      this.load_initial_products();
    },

    next_set_images(url) {
      this.next_url = "";
      this.load_next_or_previous_art(url);
      window.scrollTo(0, 0);
    },

    previous_set_images(url) {
      this.previous_url = "";
      this.load_next_or_previous_art(url);
      window.scrollTo(0, 0);
    },

    load_initial_products() {
      this.current_route_name = this.$router.currentRoute.name;

      if (this.$router.currentRoute.name === "LatestArt") {
        this.filter_string += `&ordering=-created_timestamp`;
        this.page_heading = "Latest Art";
      }

      if (this.$router.currentRoute.name === "PremiumArt") {
        this.filter_string += `&selling_price__gte=20000`;
        this.page_heading = "Premium Art";
      }

      if (this.$router.currentRoute.name === "ExploreArt") {
        this.filter_string = "";
        this.page_heading = "Explore Art";
      }

      this.loading = true;
      this.$store
        .dispatch("getProducts", this.filter_string)
        .then((res) => {
          if (res.results) {
            if (res.next) {
              this.next_url = res.next;
            }
            if (res.previous) {
              this.previous_url = res.previous;
            }
            this.$store.commit("setExploreArt", res);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$notify({
            group: "error",
            title: "Error",
            text: "Something Went Wrong",
          });
        });
    },

    load_next_or_previous_art(url) {
      let url_with_filter = url;
      this.loading = true;
      this.$store
        .dispatch("getNextOrPreviousProducts", url_with_filter)
        .then((res) => {
          if (res.results) {
            if (res.next) {
              this.next_url = res.next;
            }
            if (res.previous) {
              this.previous_url = res.previous;
            }
            if(this.artist_slug){
              this.search_art_list = res.results;
                this.search_flag = false;
                this.loading = false;
            }
            this.$store.commit("setExploreArt", res);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$notify({
            group: "error",
            title: "Error",
            text: "Something Went Wrong",
          });
        });
    },
    searchArt() {
      if (this.search_art === "") {
        this.search_flag = true;
      } else {
        this.loading = true;
        let search_meta_data = {
          filter_string: this.filter_string,
          search_keyword: this.search_art,
        };
        this.search_art = this.search_art.trim();
        if (this.search_art != "") {
          this.$store
            .dispatch("searchProduct", search_meta_data)
            .then((res) => {
              if (res.results) {
                if (res.next) {
                  this.next_url = res.next;
                }
                if (res.previous) {
                  this.previous_url = res.previous;
                }
                // this.$store.commit("setExploreArt", res);
                this.search_art_list = res.results;
                this.search_flag = false;
                this.loading = false;
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$notify({
                group: "error",
                title: "Error",
                text: "Something Went Wrong",
              });
            });
        } else {
          this.search_flag = true;
          this.search_art_list = null;
        }
      }
    },
    searchResult() {
      this.search_flag = true;
      this.search_art_list = {};
    },
  },

  computed: {
    getExploreArt() {
      return this.$store.getters.getExploreArt.results;
    },
    getHeroImageUrl() {
      if (this.current_route_name === "LatestArt")
        return require("@/assets/images/latest_art-explore_art.jpg");
      else if (this.current_route_name === "PremiumArt")
        return require("@/assets/images/premium_art-explore_art.jpg");
      else return require("@/assets/images/explore_art.jpg");
    },
  },

  mounted(){
    if(this.artist_slug){
      this.search_art = this.artist_slug
      this.searchArt()
    }
  },

  created() {
    if( !this.artist_slug){
    this.load_initial_products();
    }

    window.scrollTo(0, 0);

    this.$on("reloadView", (section) => {
      this.realoadVaraible += 1;
      this.reload();
    });

    // this.debouncedSearchArt = _.debounce(this.searchArt,500);
  },
};
</script>

<style scoped>
input:focus {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}
*:focus {
  outline: none;
  box-shadow: none;
}
@media (max-width: 992px) {
  .ex-card {
    width: 100% !important;
    margin: 0 5px;
    padding: 10px;
  }
}
</style>